import { SortDescriptor } from '@progress/kendo-data-query';

export const SortSettings: SortDescriptor[] = [
  { field: 'ticker', dir: 'asc' },
  { field: 'id', dir: 'asc' }
];
